import React, { useEffect } from "react";
import dayjs from "dayjs";
import { List } from "antd";
import { connect } from "react-redux";
import { getLeaveList } from "../../../../redux/leave/leaveState";
import { DATE_FORMAT } from "variables/constants";

const formatLeaveDate = (from, to) => {
  const start = dayjs(from);
  const end = dayjs(to);

  if (start.isSame(end, "day")) return start.format("MMM DD, YYYY");
  if (start.isSame(end, "month")) return `${start.format("MMM DD")}-${end.format("DD, YYYY")}`;
    return `${start.format("MMM DD, YYYY")} – ${end.format("MMM DD, YYYY")}`;
  };

const calculateTotalDays = (from, to) => dayjs(to).diff(dayjs(from), "day") + 1;

const LeaveTable = ({ 
  recordList, 
  pagination, 
  doSearch,
  dateRange
}) => {

  useEffect(() => {
    const filters = {
      paginate: pagination.per_page,
    };

    if (dateRange?.length === 2) {
      filters.date_from = dateRange[0].format(DATE_FORMAT);
      filters.date_to = dateRange[1].format((DATE_FORMAT));
    }

    doSearch(filters);
  }, [doSearch, pagination.per_page, dateRange]);

  return (
    <List
      dataSource={recordList}
      itemLayout="vertical"
      pagination={{
        ...pagination,
        showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,
      }}
      renderItem={(item) => {
        const statusKey = item.lve_status_name.toLowerCase();

        return (
          <List.Item key={item.lve_id} className="!p-0 !border-0 mt-2">
            <div className="p-4 border border-slate-200 rounded-xl hover:shadow-md transition-all">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-sm dark:text-white">
                    {formatLeaveDate(item.lve_date_from, item.lve_date_to)}
                  </p>
                  <div className="text-xs text-slate-700 flex items-center gap-1 dark:text-slate-100">
                    <span>{item.lve_type_name}</span>
                    <span>•</span> 
                    <span>{calculateTotalDays(item.lve_date_from, item.lve_date_to)} day(s)</span>
                  </div>
                </div>

                <span className={`status-indicator ${statusKey}`}>
                  {item.lve_status_name}
                </span>
              </div>
            </div>
          </List.Item>
        );
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  recordList: state.leave.leaveList?.items,
  pagination: state.leave.leaveList?.pagination,
  filters: state.leave.leaveList?.filters,
  requesting: state.leave.leaveList?.requesting,
  error: state.leave.leaveList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getLeaveList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveTable);
